import { render, staticRenderFns } from "./mine-serve.vue?vue&type=template&id=7d62b63c&scoped=true"
import script from "./mine-serve.vue?vue&type=script&lang=js"
export * from "./mine-serve.vue?vue&type=script&lang=js"
import style0 from "./mine-serve.vue?vue&type=style&index=0&id=7d62b63c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d62b63c",
  null
  
)

export default component.exports